import { ApiBase } from './api-base'
import type { ApiRequestConfig } from './types'

export default class ApiFactory extends ApiBase {
  /** 取得單筆資料 */
  getData<R>(url: string, config?: ApiRequestConfig): Promise<R> {
    return this.get(url, config)
  }

  /** 取得多筆資料 */
  getList<R>(
    url: string,
    query?: unknown,
    config?: ApiRequestConfig
  ): Promise<R> {
    return this.post(url, query, config)
  }

  /** 新增資料 */
  createData<R>(
    url: string,
    data: unknown,
    config?: ApiRequestConfig
  ): Promise<R> {
    return this.post(url, data, config)
  }

  /** 更新資料 */
  updateData<R>(
    url: string,
    data: unknown,
    config?: ApiRequestConfig
  ): Promise<R> {
    return this.put(url, data, config)
  }

  /** 刪除資料 */
  deleteData<R>(url: string, config?: ApiRequestConfig): Promise<R> {
    return this.delete(url, config)
  }

  downloadFile(
    config: ApiRequestConfig,
    inputFileName?: string
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.api<BlobPart>({
        ...config,
        responseType: 'blob'
      })
        .then((response) => {
          const fileName = inputFileName
            ? inputFileName
            : (((response.headers['content-disposition'] ?? '') as string)
                .split('; ')
                .map((value) => value.split('='))
                .find(([key]) => key === 'filename*')?.[1]
                ?.split(`''`)[1] ?? '')

          const link = document.createElement('a')

          link.href = window.URL.createObjectURL(new Blob([response.data]))
          link.setAttribute('download', decodeURIComponent(fileName))
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          resolve()
        })
        .catch((error) => reject(error))
    })
  }
}
